import { getCurrentRccCode, getRccFromRegionId, RccCode } from "gl-commonui";

type RegionIdentifier = {
    id?: string;
};

export function isRegionAllowedForTenant(
    regionId: string | null | undefined,
    tenantRcc: RccCode
): boolean {
    if (!regionId) {
        return false;
    }

    const regionRcc = getRccFromRegionId(regionId);
    if (tenantRcc === "ru") {
        return regionRcc === "ru";
    }

    return regionRcc !== "ru";
}

export function filterRegionsForCurrentTenant<T extends RegionIdentifier>(
    regions: T[]
): T[] {
    if (!Array.isArray(regions) || !regions.length) {
        return [];
    }

    const tenantRcc = getCurrentRccCode();
    return regions.filter((region) =>
        isRegionAllowedForTenant(region && region.id, tenantRcc)
    );
}

export function normalizeSelectedRegion<T extends RegionIdentifier>(
    selectedRegion: string | null | undefined,
    regions: T[]
): string | null {
    if (!Array.isArray(regions) || !regions.length) {
        return null;
    }

    if (
        selectedRegion &&
        regions.some((region) => region && region.id === selectedRegion)
    ) {
        return selectedRegion;
    }

    return regions[0] && regions[0].id ? regions[0].id : null;
}
